<p>Not sure how you got here but definitely shouldn't be here.</p>
<button mat-button (click)="startOver()">Back to Safety!</button>
